<script>
    import Modal from './Modal.svelte';
	import { modal } from './stores.js';
    import PopupNewInvite from './PopupNewInvite.svelte';
    export let subscription;
</script>

<Modal show={$modal}>
    <PopupNewInvite subscription={subscription} />
</Modal>